import { get } from 'utilities/http';

export const loginRedirect = async (current: string = window.location.href): Promise<void> => {

    //await get('avocet/v1/Authentication/logout');

    const url = current.split('?')[0];
    window.location.href = '/app/LM/login?redirect_uri=' + encodeURIComponent(url);
};

export const loginNoRedirect = async (): Promise<void> => {

    await get('avocet/v1/Authentication/logout');
    window.location.href = '/app/LM/login';
};